export default "\r\n<p-triStateCheckbox [(ngModel)]='data' disabled='!isEditing'>\r\n</p-triStateCheckbox>\r\n";